import { KonvaEventObject } from 'konva/types/Node';
import { KonvaPointerEvent } from 'konva/types/PointerEvents';
import { makeAutoObservable, observable } from 'mobx';
import { useObserver } from 'mobx-react-lite';
import { useCallback } from 'react';

const mouseTracker = makeAutoObservable(
  {
    event: undefined as Event | undefined,
    setEvent(event: Event | undefined) {
      mouseTracker.event = event;
    },
  },
  { event: observable.ref },
);
type Event = KonvaEventObject<KonvaPointerEvent | MouseEvent>;

export const useMouseTracker = (): readonly [Event | undefined, (evt: Event) => void] => {
  const setMouseTracker = useCallback((evt: Event) => {
    mouseTracker.setEvent(evt);
  }, []);

  return useObserver(() => [mouseTracker.event, setMouseTracker] as const);
};
